<template>
    <portal selector="#portal-target">
        <div class="modal modal_md modal_free is-active" tabindex="-1" role="dialog" >
            <div class="modal__bg" @click="closeModal"></div>
            <div class="modal__container">
                <div class="modal__header">
                     <span class="modal__close"  role="button" aria-label="Close" @click.prevent="closeModal">
                        <i class="icon icon_close"></i>
                    </span>
                </div>
                <div class="modal__body">
                    <h3 class="modal__title">Congratulations!!!</h3>
                    <p>You have activated a <span class="modal__text">Free trial</span> for your account </p>
                    <p>You can communicate without limitations and use chat and all its features</p>
                    <p> <span class="text-bold">{{Number(freeCredits/100).toFixed(0)}} credits</span> have been added to your account, you can check it <span class="modal__link" @click.prevent="gotoAccount">here</span></p>
                </div>
                <div class="modal__footer">
                    <button class="button button_md button_primary" @click.prevent="closeModal">
                        <span>Ok</span>
                    </button>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
// import FreePayment from "../modulePaymentPage/FreePayment.vue";

export default {
    name: "SuccessFreePayment",
    props: ['freeCredits'],
    // components: {FreePayment},
    mounted() {
        this.$bus.$emit('open_modal')
    },
    beforeDestroy() {
        this.$bus.$emit('close_modal')
    },
    methods:{
        gotoAccount(){
            this.$router.push({name: 'account'})
        },
        closeModal(){
            this.$emit('close_modal');
        },
    }
}
</script>

<style scoped>

</style>
